import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromRoot from '../../../../app/state/app.selectors';
import * as fromOrganization from './organization.reducers';

export interface OrganizationState {
  stateData: fromOrganization.State;
}

export interface State extends fromRoot.AppState {
  organization: OrganizationState;
}

export const reducers = {
  stateData: fromOrganization.reducer
};

export const selectOrganizationState = createFeatureSelector<OrganizationState>('organization');

export const selectOrganizationStateData = createSelector(selectOrganizationState, (state: OrganizationState) => state.stateData);

export const getOrganizationState = createSelector(selectOrganizationStateData, fromOrganization.getStateData);

export const getOrganizationScreenError = createSelector(selectOrganizationStateData, fromOrganization.getError);

export const getOrganizationScreenPending = createSelector(selectOrganizationStateData, fromOrganization.getPending);